import { createContext } from 'react';

import { Product, ProductContextType } from './types';

const ProductContext = createContext<ProductContextType>({ product: ({} as unknown) as Product });

export default ProductContext;
